import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder, StringDecoder } from '@common/encoding';
import { encodeSortList, SortListDecoder } from '@stamhoofd/filters/SortList';
import { StamhoofdFilterJSONDecoder } from './StamhoofdFilterDecoder.js';
export { StamhoofdFilterDecoder, StamhoofdFilterJSONDecoder } from './StamhoofdFilterDecoder.js';
export class CountResponse extends AutoEncoder {
    count;
}
__decorate([
    field({ decoder: IntegerDecoder })
], CountResponse.prototype, "count", void 0);
export class CountFilteredRequest {
    filter;
    search;
    constructor(data) {
        this.filter = data.filter ?? null;
        this.search = data.search ?? null;
    }
    static decode(data) {
        return new CountFilteredRequest({
            filter: data.optionalField('filter')?.nullable(StamhoofdFilterJSONDecoder),
            search: data.optionalField('search')?.nullable(StringDecoder),
        });
    }
    encode(context) {
        return {
            filter: this.filter ? StamhoofdFilterJSONDecoder.encode(this.filter, context) : undefined,
            search: this.search ?? undefined,
        };
    }
}
export class LimitedFilteredRequest {
    /**
     * This is the base filter
     */
    filter;
    /**
     * This is a filter than get extended to fetch the next page
     */
    pageFilter;
    sort;
    limit;
    search;
    constructor(data) {
        this.filter = data.filter ?? null;
        this.pageFilter = data.pageFilter ?? null;
        this.sort = data.sort ?? [];
        this.limit = data.limit;
        this.search = data.search ?? null;
    }
    static decode(data) {
        return new LimitedFilteredRequest({
            filter: data.optionalField('filter')?.nullable(StamhoofdFilterJSONDecoder),
            pageFilter: data.optionalField('pageFilter')?.nullable(StamhoofdFilterJSONDecoder),
            sort: data.field('sort').decode(SortListDecoder),
            limit: data.field('limit').integer,
            search: data.optionalField('search')?.nullable(StringDecoder),
        });
    }
    encode(context) {
        return {
            filter: this.filter ? StamhoofdFilterJSONDecoder.encode(this.filter, context) : undefined,
            pageFilter: this.pageFilter ? StamhoofdFilterJSONDecoder.encode(this.pageFilter, context) : undefined,
            sort: encodeSortList(this.sort),
            limit: this.limit,
            search: this.search ?? undefined,
        };
    }
}
//# sourceMappingURL=FilteredRequest.js.map